import React from 'react';

const WN_PANEL_CLASS = 'whats-new__panel';
const PANEL_DEFAULT_WIDTH = 450;
const VIEWPORT_MARGIN = 16;

export default function adjustPanelPosition(
    panelRef: React.RefObject<HTMLDivElement>,
    iconRef: React.RefObject<HTMLDivElement>,
    setPanelStyle: React.Dispatch<React.SetStateAction<React.CSSProperties>>
): void {
    const container = panelRef.current;
    const icon = iconRef.current;
    const panel = container && (container.querySelector(`.${WN_PANEL_CLASS}`) as HTMLDivElement | null);

    if (!panel || !icon || !container) return;

    const iconButton = icon.querySelector('button');
    const iconRect = (iconButton || icon).getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    const panelWidth = panel.getBoundingClientRect().width || panel.offsetWidth || PANEL_DEFAULT_WIDTH;
    const viewportWidth = document.documentElement.clientWidth || window.innerWidth;

    const iconCenterX = iconRect.left + iconRect.width / 2;
    const rightSideLeft = iconCenterX - containerRect.left - panelWidth * 0.1;
    const overflowRight = Math.max(
        0,
        containerRect.left + rightSideLeft + panelWidth - (viewportWidth - VIEWPORT_MARGIN)
    );

    const rawLeft = rightSideLeft - overflowRight;
    const panelLeft = Math.max(
        VIEWPORT_MARGIN - containerRect.left,
        Math.min(rawLeft, viewportWidth - VIEWPORT_MARGIN - panelWidth - containerRect.left)
    );

    const arrowLeft = iconCenterX - (containerRect.left + panelLeft);

    setPanelStyle({
        left: `${panelLeft}px`,
        visibility: 'visible',
        '--arrow-left': `${Math.max(16, Math.min(arrowLeft, panelWidth - 16))}px`,
    } as React.CSSProperties);
}
